<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_116_1462)">
      <path d="M15.6818 19.2175C13.1761 21.7232 9.24346 21.9322 6.49976 19.8445C6.2501 19.6545 6.01029 19.4455 5.7823 19.2175C5.55429 18.9895 5.34529 18.7497 5.15532 18.5C3.06764 15.7563 3.27664 11.8237 5.7823 9.31804C8.51597 6.58437 19.2173 5.78251 19.2173 5.78251C19.2173 5.78251 18.4155 16.4839 15.6818 19.2175Z" stroke="currentColor" stroke-width="1.5"/>
      <path d="M5.15526 18.5C5.34524 18.7497 5.55423 18.9895 5.78224 19.2175C6.01024 19.4455 6.25005 19.6545 6.4997 19.8445C7.99966 17 10.9997 13.5 14.9997 9.50003C9.79966 12.474 6.99976 16 5.15526 18.5Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_116_1462">
        <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
      </clipPath>
    </defs>
  </svg>
</template>
